export const styles = {
    dont1: {
        top: '-40px',
        left: '-80px',
        width: '10px',
        height: '10px',
        backgroundColor: '#ff6b6b',
        zIndex: 1
    },
    dont2: {
        top: '-100px',
        right: '-80px',
        width: '10px',
        height: '10px',
        backgroundColor: '#ff6b6b',
        zIndex: 1
    },
    lineWrapper: {
        top: '-120px',
        right: '-227px',
        zIndex: 0,
        pointerEvents: 'none'
    },
    container: {
        position: 'relative',
        width: '100%',
        padding: '10px 20px',
        backgroundColor: '#fff',
        minHeight: '600px',
    },
    header: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '30px'
    },
    billingToggle: {
        display: 'flex',
        gap: '0',
        backgroundColor: '#f5f5f5',
        borderRadius: '25px',
        padding: '4px',
        border: '1px solid #e0e0e0'
    },
    toggleButton: {
        padding: '10px 30px',
        border: 'none',
        borderRadius: '20px',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: '500',
        color: '#666',
        transition: 'all 0.3s ease'
    },
    toggleButtonActive: {
        backgroundColor: '#7bb321',
        color: '#fff'
    },
    badge: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '20px',
        // paddingRight: '40px',
    },
    noCreait: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px 12px",
        backgroundColor: "#F9F9F9",
        borderRadius: "30px",
        gap: "1rem",
    },
    badgeText: {
        fontSize: '23px',
        color: '#83B81E',
        fontWeight: '700',
    },
    scrollContainer: {
        width: "100%",
        paddingBottom: '20px',
        scrollbarWidth: 'thin',
        scrollbarColor: '#7bb321 #f5f5f5',
        overflowX: "auto",
        overflowY: "hidden",
        scrollBehavior: "smooth",
    },
    pricingGrid: {
        display: 'flex',
        gap: '16px',
        minWidth: '100%',
        width: "100%",
        // justifyContent: "center",
        margin: "0 auto",
        overflowX: "unset",
        overflowY: "unset",
    },
    card: {
        position: 'relative',
        backgroundColor: '#fff',
        borderRadius: '20px',
        padding: '24px',
        border: '2px solid #e0e0e0',
        transition: 'all 0.3s ease',
        minHeight: '500px',
        width: 'max-content',
        minWidth: '320px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
    },
    smallCard:{
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        padding: '15px 20px',
        position: 'relative',
        backgroundColor: '#fff',
        borderRadius: '8px',
        border: '2px solid #e0e0e0',
        transition: 'all 0.3s ease',
        width: '100px',
    },
    popularBadge: {
        backgroundColor: '#ff8c00',
        color: '#fff',
        padding: '6px 12px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: 'bold',
        letterSpacing: '0.5px',
        width: 'fit-content',
        display: 'flex',
        justifyContent: "flex-end"
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: 1,
        width: '100%',
        gap: "8px" // CHANGED from "12px" to "8px" for tighter spacing
    },
    priceSection: {
        display: 'flex',
        alignItems: 'baseline',
        marginBottom: '4px', 
        gap: '8px' 
    },
    price: {
        fontSize: '28px',
        fontWeight: 'bold',
        lineHeight: '1'
    },
    period: {
        fontSize: '12px',
    },
    employees: {
        fontSize: '14px',
        marginBlockEnd: 0,
        marginBlockStart: 0,
        marginBottom: '4px' // ADD THIS for consistent spacing
    },
    planName: {
        fontSize: '25px',
        fontWeight: 'bold',
        marginBottom: '8px', // ADD THIS
        marginTop: '4px' // ADD THIS for consistent spacing
    },
    description: {
        fontSize: '14px',
        lineHeight: '1.6',
        // marginBottom: '12px', // ADD THIS to create space before features
        // minHeight: '60px' // ADD THIS to ensure consistent height
    },
    planButton: {
        width: '100%',
        padding: '12px 20px',
        border: 'none',
        borderRadius: '20px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        marginTop: 'auto' // ADD THIS to push button to bottom
    },
    dot: {
        position: 'absolute',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        opacity: 0.6
    },
    featureItem: {
        display: "flex",
        alignItems: "flex-start",
        gap: "8px", // CHANGED from 1 to "8px"
        marginBottom: "8px", // ADD THIS for spacing between features
        width: "100%"
    },
    checkIcon: {
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: "#D1FAE5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        marginTop: "2px" // ADD THIS to align with text
    },
    featureText: {
        fontSize: "14px",
        color: "#374151",
        lineHeight: "1.5",
        margin: 0,
        flex: 1
    },
    // ADD THIS NEW STYLE for the features container
    featuresContainer: {
        width: '100%',
        marginTop: '0', // No extra margin at top
        marginBottom: '16px', // Space before button
        flex: 1 // Takes available space
    }
}